export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          alt="Abu Ayaan Services Office" 
          className="w-full h-full object-cover object-top" 
          src="https://public.readdy.ai/ai/img_res/e7131271298b665d96e3fde02e31a9e7.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
          
        </h1>
        <p className="text-2xl md:text-3xl text-white/90 mb-4 font-serif italic">
          Professional Cleaning & Staff Deployment Solutions in Bahrain
        </p>
        <p className="text-lg text-white/80 mb-12 font-light">
          Deploying Skilled Staff at Your Premises - Helpers, Office Boys & Cleaners on Contract Basis
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#contact" 
            className="bg-teal-500 text-white px-8 py-4 rounded-full text-base font-medium hover:bg-teal-600 transition-all flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl cursor-pointer"
          >
            Get a Quote
            <i className="ri-arrow-right-line"></i>
          </a>
          <a 
            href="tel:+97336096336" 
            className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white hover:text-teal-500 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Call +973 36096336
          </a>
        </div>
      </div>
    </section>
  );
}
